// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PFK38Xqe5rndC4gbFKKk {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Loader css come from: https://loading.io/css/ */

.q8mczlCgTy7gLDwhCHZe {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.q8mczlCgTy7gLDwhCHZe div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  border-radius: 50%;
  animation: q8mczlCgTy7gLDwhCHZe 1.2s linear infinite;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}
.q8mczlCgTy7gLDwhCHZe div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

@keyframes q8mczlCgTy7gLDwhCHZe {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Loading/Loading.module.css"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kDAAkD;;AAElD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wDAAsB;EACtB,kBAAkB;EAClB,oDAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["@value colors: '../style/colors.css';\n@value color-gray from colors;\n\n.loadingContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Loader css come from: https://loading.io/css/ */\n\n.loading {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.loading div {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  background: color-gray;\n  border-radius: 50%;\n  animation: loading 1.2s linear infinite;\n}\n.loading div:nth-child(1) {\n  animation-delay: 0s;\n  top: 37px;\n  left: 66px;\n}\n.loading div:nth-child(2) {\n  animation-delay: -0.1s;\n  top: 22px;\n  left: 62px;\n}\n.loading div:nth-child(3) {\n  animation-delay: -0.2s;\n  top: 11px;\n  left: 52px;\n}\n.loading div:nth-child(4) {\n  animation-delay: -0.3s;\n  top: 7px;\n  left: 37px;\n}\n.loading div:nth-child(5) {\n  animation-delay: -0.4s;\n  top: 11px;\n  left: 22px;\n}\n.loading div:nth-child(6) {\n  animation-delay: -0.5s;\n  top: 22px;\n  left: 11px;\n}\n.loading div:nth-child(7) {\n  animation-delay: -0.6s;\n  top: 37px;\n  left: 7px;\n}\n.loading div:nth-child(8) {\n  animation-delay: -0.7s;\n  top: 52px;\n  left: 11px;\n}\n.loading div:nth-child(9) {\n  animation-delay: -0.8s;\n  top: 62px;\n  left: 22px;\n}\n.loading div:nth-child(10) {\n  animation-delay: -0.9s;\n  top: 66px;\n  left: 37px;\n}\n.loading div:nth-child(11) {\n  animation-delay: -1s;\n  top: 62px;\n  left: 52px;\n}\n.loading div:nth-child(12) {\n  animation-delay: -1.1s;\n  top: 52px;\n  left: 62px;\n}\n\n@keyframes loading {\n  0%, 20%, 80%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `'../style/colors.css'`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"loadingContainer": `PFK38Xqe5rndC4gbFKKk`,
	"loading": `q8mczlCgTy7gLDwhCHZe`
};
export default ___CSS_LOADER_EXPORT___;
